import { createFileRoute } from '@tanstack/react-router';

import { GerminationDetailPage } from '@/modules/germination-test/components/germination-detail-page';
import { germinationDetailSearchSchema } from '@/modules/germination-test/utils/germination-search';

function AcceleratedAgingRoutePage() {
  const { id } = Route.useParams();
  const { setup, ...listSearch } = Route.useSearch();

  return <GerminationDetailPage id={id} listSearch={listSearch} setup={!!setup} testKind="EA" />;
}

export const Route = createFileRoute('/seeds/accelerated-aging/$id')({
  validateSearch: germinationDetailSearchSchema,
  component: AcceleratedAgingRoutePage,
});
